import styled from 'styled-components'

import { Checkbox } from './checkbox'

import type * as RadixCheckbox from '@radix-ui/react-checkbox'

type CheckboxFieldProps = {
  label: string
  checked: boolean
} & React.ComponentPropsWithRef<typeof RadixCheckbox.Root> & {}

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
  label,
  className,
  ...props
}) => {
  return (
    <Root className={className}>
      <Checkbox {...props} />
      <Label className="label">{label}</Label>
    </Root>
  )
}

const Root = styled.label`
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  gap: 6px;
`

const Label = styled.div``
